/*global ActiveXObject:false*/
define('lib/Podio.Browser',['require'],function(require) {

  var browserInfo = {
    flashVersion          : 0,
    cssTransitionEndEvent : ''
  };

  function detectBrowserPrefix() {
    var styles = window.getComputedStyle(document.documentElement, ''),
      pre = (Array.prototype.slice
        .call(styles)
        .join('')
        .match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o'])
        )[1];

    if (!pre) {
      return '';
    }

    return ('WebKit|Moz|MS|O').match(new RegExp('(' + pre + ')', 'i'))[1].toLowerCase();
  }

  function detectFlashVersion() {
    var version;

    try {
      version = navigator.plugins['Shockwave Flash'];
      version = version.description;
    } catch ( e1 ) {
      try {
        version = new ActiveXObject('ShockwaveFlash.ShockwaveFlash').GetVariable('$version');
      } catch ( e2 ) {
        version = '0.0';
      }
    }

    version = version.match(/\d+/g);

    browserInfo.flashVersion = parseFloat(version[0] + '.' + version[1]);
  }

  function detectWindows() {
    browserInfo.isWindows = navigator.platform && navigator.platform.indexOf('Win') !== -1;
  }

  function detectCSSEventNames() {
    var browserPrefix = detectBrowserPrefix();

    browserInfo.prefixed = function (value) {
      return browserPrefix + value.charAt(0).toUpperCase() + value.slice(1);
    };
    browserInfo.prefix = browserPrefix;

    browserInfo.cssTransitionEndEvent = 'webkitTransitionEnd transitionend oTransitionEnd msTransitionEnd';
    browserInfo.cssAnimationEndEvent = 'webkitAnimationEnd animationend oAnimationEnd msAnimationEnd';
  }

  function initialize() {
    detectFlashVersion();
    detectCSSEventNames();
    detectWindows();
  }

  initialize();

  return browserInfo;

});

